export const SET_FREE = "SET_FREE";
export const SET_DOOR = "SET_DOOR";
export const SET_ONLINE = "SET_ONLINE";
export const CLEAR = "CLEAR";
